export enum TextMessageScheduleOption {
  DAYS_AFTER_FILL = 'days_after_session_end',
  AFTER_FILL = 'after_session_end',
  DAYS_AFTER_USER_DEFINED_TIME = 'days_after_user_defined_time',
}
